import type { BreadcrumbDesignTokens } from '@primeuix/themes/types/breadcrumb'

export default {
  item: {
    gap: '{navigation.item.gap}',
    icon: {
      color: '{surface.700}',
      hoverColor: '{surface.800}',
    },
    color: '{surface.700}',
    focusRing: {
      color: '{focus.ring.color}',
      style: '{focus.ring.style}',
      width: '{focus.ring.width}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
    hoverColor: '{surface.800}',
    borderRadius: '{content.border.radius}',
  },
  root: {
    gap: '0.5rem',
    padding: '1.25rem',
    background: '{content.background}',
    transitionDuration: '{transition.duration}',
  },
  separator: {
    color: '{surface.500}',
  },
} satisfies BreadcrumbDesignTokens
